import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthRequest } from "src/app/shared/models/AD/ auth-request.model";
import { AuthResponse } from "src/app/shared/models/AD/auth-response.model";
import { RefreshTokenRequest } from "src/app/shared/models/AD/refresh-token-request.model";
import { RefreshTokenResponse } from "src/app/shared/models/AD/refresh-token-response.model";
import { environment } from "src/environments/environment";
import { Router } from '@angular/router';
import { CookieService } from "./cookie.service";
import { User } from "../models/user.model";
import { UsersApiService } from "src/app/shared/services/users.api.service";

@Injectable({
	providedIn: 'root'
})
export class AuthService {
	private readonly authenticationUrl = environment.authenticationUrl;
	private readonly apiUrl = environment.webApi;

	constructor(
		private readonly http: HttpClient,
		private readonly router: Router,
		private readonly cookieService: CookieService,
		private readonly usersApi: UsersApiService
	) { }

	signIn(authRequest: AuthRequest): Observable<AuthResponse> {
		return this.http.post<AuthResponse>(this.authenticationUrl + '/sign-in', authRequest);
	}

	refreshToken(refreshTokenRequest: RefreshTokenRequest): Observable<RefreshTokenResponse> {
		return this.http.post<RefreshTokenResponse>(this.authenticationUrl + '/refresh-token', refreshTokenRequest);
	}

	getUserDetails(res: AuthResponse): Observable<User> {
		let username = res.username;
		return this.usersApi.getUserDetails(username, true);
	}

	logout() {
		this.cookieService.delete('authResponse');
		this.cookieService.delete('active-user');
		const currentUrl = this.router.url;
		this.router.navigate(['/login'], {
			queryParams: { returnUrl: currentUrl }
		});
	}
}